import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import ReactModal from 'react-modal';
import merge from 'deepmerge';

import ErrorModal from '../ErrorModal';
import ModalNavHeader from '../ModalNavHeader';
import ModalFooter from '../ModalFooter';

import './ActionModal.scss';

const actionModalDefaultStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    overflowY: 'auto',
    zIndex: '6',
  },
  content: {
    background: '#fff',
    borderRadius: '12px',
    left: '15px',
    margin: 'auto',
    maxWidth: '400px',
    maxHeight: '620px',
    outline: 'none',
    overflow: 'hidden',
    padding: '0px',
    right: '15px',
  },
};

const ActionModal = (props) => {
  const {
    children, error, modalNavHeaderProps, modalFooterProps, onErrorModalClose, styles,
  } = props;

  const {
    isErrorModalOpen, message, title,
  } = error;

  const errorModalProps = {
    message,
    primaryCTAKey: 'got_it',
    primaryCTAText: 'Got It',
    primaryCTAOnClick: onErrorModalClose,
    primaryCTAVariant: 'primary',
    title,
    onErrorModalClose,
  };

  return (
    <>
      <ReactModal style={merge(actionModalDefaultStyles, styles)} {...props} shouldCloseOnEsc>
        {!isEmpty(modalNavHeaderProps) && (
          <ModalNavHeader {...modalNavHeaderProps} />
        )}
        <div className="ActionModalBody">
          {children}
        </div>
        {!isEmpty(modalFooterProps) && (
          <div className="ActionModalFooter">
            <ModalFooter {...modalFooterProps} />
          </div>
        )}
      </ReactModal>
      {isErrorModalOpen && <ErrorModal style={merge(actionModalDefaultStyles, styles)} {...errorModalProps} /> }
    </>
  );
};

ActionModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  error: PropTypes.shape({
    isErrorModalOpen: PropTypes.bool,
    message: PropTypes.string,
    title: PropTypes.string,
  }),
  modalNavHeaderProps: PropTypes.shape(ModalNavHeader.propTypes),
  modalFooterProps: PropTypes.shape(ModalFooter.propTypes),
  onErrorModalClose: PropTypes.func,
  styles: PropTypes.shape({
    overlay: PropTypes.shape({}),
    content: PropTypes.shape({}),
  }),
};

ActionModal.defaultProps = {
  error: {
    isErrorModalOpen: false,
    message: undefined,
    title: undefined,
  },
  modalNavHeaderProps: {},
  modalFooterProps: {},
  onErrorModalClose: undefined,
  styles: {},
};

ActionModal.displayName = 'ActionModal';
export default ActionModal;
